/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var Tab = {
  key: 'Tab',
  which: 9,
  keyCode: 9
};
var Enter = {
  key: 'Enter',
  which: 13,
  keyCode: 13
};
var Escape = {
  key: ['Escape',
  // IE11 Escape
  'Esc'],
  which: 27,
  keyCode: 27
};
var Space = {
  key: ' ',
  which: 32,
  keyCode: 32
};
var PageUp = {
  key: 'PageUp',
  which: 33,
  keyCode: 33
};
var PageDown = {
  key: 'PageDown',
  which: 34,
  keyCode: 34
};
var End = {
  key: 'End',
  which: 35,
  keyCode: 35
};
var Home = {
  key: 'Home',
  which: 36,
  keyCode: 36
};
var ArrowLeft = {
  key: 'ArrowLeft',
  which: 37,
  keyCode: 37
};
var ArrowUp = {
  key: 'ArrowUp',
  which: 38,
  keyCode: 38
};
var ArrowRight = {
  key: 'ArrowRight',
  which: 39,
  keyCode: 39
};
var ArrowDown = {
  key: 'ArrowDown',
  which: 40,
  keyCode: 40
};

export { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, End, Enter, Escape, Home, PageDown, PageUp, Space, Tab };
